import './index.scss'
import fullpage from 'fullpage.js'
import 'fullpage.js/dist/fullpage.min.css'
import Swiper from 'swiper/swiper-bundle.min'
import '../../assets/scripts/jquery.mousewheel'

!(function(){
  $('header').addClass('white')
})()

$(document).ready(function(){
  if($(window).width() > 1024){
    initFullpage()
  }
})

//全屏滚动
var afullpage;
function initFullpage() {
  afullpage = new fullpage('#fullpage', {
    scrollingSpeed: 600,
    css3: true,
    resize:true,
    autoScrolling: true,
    scrollBar: false,
    anchors: ['page1', 'page2', 'page3', 'page4'],
		menu: '#menu',
    afterLoad: function (origin, destination, direction, trigger) {
      let i = destination.index;
      if(i == 0){
        // numScroll ()
        $('#menu').css({'opacity':'0'})
        $('header').addClass('white')
      }else{
        $('#menu').css({'opacity':'1'})
        $('header').removeClass('white')
      }
      if(i == 3){
        afullpage.setAllowScrolling(false);
      }
    },
    onLeave: function (origin, destination, direction,trigger) {
      if(origin.index == 1 && destination.index == 0){
        $('#menu').css({'opacity':'0'})
        $('header').addClass('white')
      }
    }
  });
}
$('#menu li').on('click',function(){
  afullpage.setAllowScrolling(true);
  $('.fixed-footer').removeClass('show')
})
//底部footer效果
function footerF(event, delta){
  let footerH = $('.fixed-footer').outerHeight()
  if(delta > 0){//返回，上滚
    if(!$('.fixed-footer').hasClass('show')){
      afullpage.setAllowScrolling(true);
    }else{
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.trans-menu').css('transform','translateY(-50%)')
    }
  }else if(delta < 0){//下滚，显示footer
    if(!$('.fixed-footer').hasClass('show')){
      $('.fixed-footer').addClass('show')
      $('.footer-tran').css('transform','translateY('+ -footerH +'px)')
      $('.trans-menu').css('transform',' translateY(calc(-50% - '+ footerH +'px))')
    }
  }
  event.preventDefault();
}

if($(window).width() > 1024){
  $('#fullpage .section3').bind('mousewheel',function(event, delta) {
    footerF(event, delta)
  });
  $('.fixed-footer').mousewheel(function(event, delta) {
    if(delta > 0){//返回，上滚
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.trans-menu').css('transform','translateY(-50%)')
    }
    event.preventDefault();
  });
}

var swiper1 = new Swiper(".section3 .right-swiper .mySwiper", {
  autoHeight: true,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  allowTouchMove: true,
  breakpoints: {
    1025: {  //当屏幕宽度小于等于1024
      autoHeight: false,
      allowTouchMove: false,
    }
  },
  navigation: {
    nextEl: ".section3 .right-swiper .swiper-button-next",
    prevEl: ".section3 .right-swiper .swiper-button-prev",
  },
  on: {
    init: function(swiper){
      $('.section3 .left-tab a').eq(this.activeIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section3 .left-tab a').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
  },

});

var mouseover_tid = [];
var mouseout_tid = [];
$(document).ready(function () {
  $(".section3 .left-tab a").each(function (index) {
    $(this).hover(
      // 鼠标进入
      function () {
        var _self = this;
        // 停止卷起事件
        clearTimeout(mouseout_tid[ index ]);
        // 当鼠标进入超过 0.2 秒, 展开菜单, 并记录到线程 ID 中
        mouseover_tid[ index ] = setTimeout(function () {
          let index = $(_self).index()
          swiper1.slideTo(index)
        }, 201);
      },
      // 鼠标离开
      function () {
        var _self = this;
        // 停止展开事件
        clearTimeout(mouseover_tid[ index ]);
        // 当鼠标离开超过 0.2 秒, 卷起菜单, 并记录到线程 ID 中
        mouseout_tid[ index ] = setTimeout(function () {
        }, 201);
      });
    });
});
